export const REGEX = {
  CUID: /^c[0-9a-z]{24}$/,
  ZIP_CODE: /^[A-Za-z0-9\s-]+$/,
  PHONE_NUMBER: /^\+?\d+$/,
  EMAIL:
    /^(?!\.)(?!.*\.$)(?!.*\.\.)(?!.*[._-]$)(?!.*[._-]{2})[a-zA-Z0-9._-]+@[a-zA-Z0-9]+\.+[a-zA-Z]{2,}$/,
  STREET_ADDRESS: /^(?!.*--)(?!.*,,)(?!.*\.\.)(?!.*,-)(?!.*,-)[A-Za-z0-9\s,-.]*$/,
  CITY: /^[A-Za-z\s-]+$/,
  COUNTRY: /^[A-Za-z\s-]+$/,
  COMPANY_NAME: /^[A-Za-z0-9](?!.*?[^\s\w.-])([A-Za-z\d\s\-.]*)(?<![.\s-])$/,
  CODE: /^[A-Za-z0-9]+$/,
  CODE_NEW: /^[A-Za-z]{4}[0-9]{4}$/,
  USER_NAME: /^[A-Za-z]+( [A-Za-z]*)*$/,
  PASSWORD: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[?!/])[A-Za-z\d?!/]+/,
  LICENSE_PLATE_NUMBER:
    /^(?!.*[!@#$%^&*()+=[\]{}|;':",.<>?])(?!.*-{2,})[^\p{P}-][\p{L}\p{N}-]*[^\p{P}-]$/u,
  BOOKING_NUMBER:
    /^(?!-)(?!.*--)(?=.*[A-Za-z0-9])[A-Za-z0-9]+([-]{1}[A-Za-z0-9]+){0,1}([-]{1}[A-Za-z0-9]+){0,1}$/,
  URL: /(https?:\/\/[^\s]+)|(http?:\/\/[^\s]+)/g,
  BLOCK_ROWS: {
    test: (rows: string, rowsRange?: number[]) => {
      const regex = /^[1-9]\d*-[1-9]\d*$/;
      if (!regex.test(rows)) return false;

      const rowsStartEnd = rows.split('-');
      const start = parseInt(rowsStartEnd[0]);
      const end = parseInt(rowsStartEnd[1]);
      const isValid = start > 0 && end > 0 && start <= end;

      if (!rowsRange) return isValid;

      return isValid && rowsRange.includes(start) && rowsRange.includes(end);
    },
  },
};
